/**
Project: Voice Panel (c)
Title: Filter Users 
Description: Component to dispay the user filter page.
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/

import React, { Component } from "react";
import {
  Flex,
  Text,
  Input,
  Button,
  Dialog,
  Divider,
  RadioGroup,
  FormLabel,
  Dropdown,
  Ref,
} from "@fluentui/react-northstar";
import { Grid, Row, Col } from "react-flexbox-grid";
import axios from "axios";
import PageUtil from "../../../../core/helpers/page-util";
import IntlUtil from "../../../../core/helpers/intl-util";
import { VoiceAdminConstants } from "../../common/settings/voice-admin-constants";
import _ from "lodash";
import { getCountryList } from "../../common/actions/general-actions";

class UserFilter extends Component {
  _isMounted = false;
  _axiosSource = axios.CancelToken.source();
  _cancelToken = { cancelToken: this._axiosSource.token };
  _intl_ns_common = "common";
  _intl_ns_vpa_common = "vpa_common";
  _intl_ns_vpa_users = "vpa_users";

  constructor(props) {
    super(props);
    this.usersPageTableRef = React.createRef();
    this.state = {
      isFormDataFilled: false,
      isFormDataErrorStatus: false,
      searchCriteria: this.searchCriteria(),
      duplicateSearchCriteria: this.searchCriteria(),
      userNextLink: null,
      errorMessage: null,
      numberAssignmentStatusList: VoiceAdminConstants.USERS.PHONE_ASSIGN_STATUS,
    };
  }

  setStateAsync = (state) => {
    if (this._isMounted) {
      return new Promise((resolve) => {
        this.setState(state, resolve);
      });
    }
  };

  async componentDidMount() {
    this._isMounted = true;
    PageUtil.scrollToTop();
    // await this.loadPageData();
  }

  async componentWillUnmount() {
    this._isMounted = false;
    this._axiosSource.cancel(
      IntlUtil.getText(
        this._intl_ns_common,
        "notification.warning.requestCancelled"
      )
    );
  }

  searchCriteria = () => {
    return {
      name: this.props.searchCriteria.name
        ? this.props.searchCriteria.name
        : "",
      email: this.props.searchCriteria.email
        ? this.props.searchCriteria.email
        : "",
      phone: this.props.searchCriteria.phone
        ? this.props.searchCriteria.phone
        : "",
      policyId: this.props.searchCriteria.policyId
        ? this.props.searchCriteria.policyId
        : "",
        usageLocation: this.props.searchCriteria?.usageLocation ?? "",
      numberAssignmentStatus:
        this.props.searchCriteria?.numberAssignmentStatus ?? "",
      filterType: VoiceAdminConstants.USERS.FILTER_CONDITIONS.ANY_CONDITIONS,
      pageSize: VoiceAdminConstants.USERS.PAGE_SIZE,
      nextLink: null,
    };
  };

  checkformFieldData = async () => {
    if (
      this.state.searchCriteria &&
      (this.state.searchCriteria.email?.trim() ||
        this.state.searchCriteria.phone?.trim() ||
        this.state.searchCriteria.name?.trim() ||
        this.state.searchCriteria.policyId?.trim() ||
        this.state.searchCriteria.usageLocation?.trim() ||
        this.state.searchCriteria.numberAssignmentStatus?.trim())
    ) {
      await this.setStateAsync({ isFormDataFilled: true });
    } else {
      await this.setStateAsync({ isFormDataFilled: false });
    }
  };

  setAddFormFieldValue = async (fieldName, fieldValue) => {
    if (fieldName && this.state.searchCriteria) {
      await this.setStateAsync({
        searchCriteria: {
          ...this.state.searchCriteria,
          [fieldName]: fieldValue ? fieldValue : "",
        },
      });
      await this.checkformFieldData();
      await this.clearAlert();
    }

    await this.validateSearchFormField();
  };

  clearAlert = async () => {
    await this.setStateAsync({
      errorMessage: null,
      isFormDataErrorStatus: false,
    });
  };

  validateSearchFormField = async () => {
    let isSearchFormValid = true;
    const regExp = /^[0-9/b]+$/g; // Regex validate Pnone Number
    if (this.state.searchCriteria && this.state.searchCriteria.phone.trim()) {
      if (regExp.test(this.state.searchCriteria.phone) === false) {
        isSearchFormValid = false;
        await this.setStateAsync({
          isFormDataErrorStatus: true,
          errorMessage: IntlUtil.getText(
            this._intl_ns_vpa_users,
            "notification.error.phoneNumberOnly"
          ),
        });
        await this.setStateAsync({ isFormDataFilled: false });
      } else if (this.state.searchCriteria.phone.startsWith("0") === true) {
        isSearchFormValid = false;
        await this.setStateAsync({
          isFormDataErrorStatus: true,
          errorMessage: IntlUtil.getText(
            this._intl_ns_vpa_users,
            "notification.error.phoneNumberZero"
          ),
        });
        await this.setStateAsync({ isFormDataFilled: false });
      } else if (
        parseInt(this.state.searchCriteria.phone.length) <= parseInt(1)
      ) {
        isSearchFormValid = false;
        await this.setStateAsync({
          isFormDataErrorStatus: true,
          errorMessage: IntlUtil.getText(
            this._intl_ns_vpa_users,
            "notification.error.phoneNumberTwoDigits"
          ),
        });
        await this.setStateAsync({ isFormDataFilled: false });
      }
    }

    return isSearchFormValid;
  };

  getConditions() {
    return [
      {
        key: VoiceAdminConstants.USERS.FILTER_CONDITIONS.ANY_CONDITIONS,
        label: IntlUtil.getText(
          this._intl_ns_vpa_users,
          "content.anyOneConditions"
        ),
        value: VoiceAdminConstants.USERS.FILTER_CONDITIONS.ANY_CONDITIONS,
      },
      {
        key: VoiceAdminConstants.USERS.FILTER_CONDITIONS.ALL_CONDITIONS,
        label: IntlUtil.getText(
          this._intl_ns_vpa_users,
          "content.allConditions"
        ),
        value: VoiceAdminConstants.USERS.FILTER_CONDITIONS.ALL_CONDITIONS,
      },
    ];
  }

  handleSearch = async (page) => {
    await this.props.hideDialogBox();
    let isSearchFormValid = await this.validateSearchFormField();
    if (isSearchFormValid === true) {
      await this.setStateAsync({
        searchCriteria: {
          ...this.state.searchCriteria,
          nextLink: "",
        },
      });
      await this.setStateAsync({
        duplicateSearchCriteria: this.state.searchCriteria,
      });
      let queryData = this.state.searchCriteria;
      await this.props.setFilterSearch(queryData);
    }
  };

  getListOfPolicy = (policys) => {
    let sortedPolicies = [];

    if (policys && policys.length > 0) {
      policys = [""].concat(policys);
      sortedPolicies = _.orderBy(
        policys,
        (policy) => policy.toLowerCase(),
        "asc"
      );
    }

    return sortedPolicies;
  };

  closeDialogBox = async () => {
    await this.props.hideDialogBox();
    await this.setStateAsync({
      searchCriteria: this.state.duplicateSearchCriteria,
    });
    await this.clearAlert();
    await this.checkformFieldData();
  };

  clearFilters = async () => {
    await this.setStateAsync({
      searchCriteria: this.clearSearchCriteria(),
      duplicateSearchCriteria: this.clearSearchCriteria(),
    });
    await this.handleSearch("clear");
  };

  clearSearchCriteria = () => {
    return {
      name: "",
      email: "",
      phone: "",
      policyId: "",
      usageLocation: "",
      numberAssignmentStatus: "",
      filterType: VoiceAdminConstants.USERS.FILTER_CONDITIONS.ANY_CONDITIONS,
      pageSize: VoiceAdminConstants.USERS.PAGE_SIZE,
      nextLink: null,
    };
  };
  setCountryList = (key) => {
    console.log(key)
    let country = null;
    if (this.props.countryStatesData?.length > 0) {
      country=this.props.countryStatesData.find(
        (country) => key?.toLowerCase() === country?.countryCode?.toLowerCase()
      );
    }
    console.log(country)

    return country?.countryName;
  };

  handleCountryChange = async (e, option) => {
    if (this.props.countryStatesData?.length > 0) {
      let country = null;
      country = this.props.countryStatesData.find(
        (con) =>
          con.countryName?.toLowerCase().trim() === option.value?.toLowerCase()
      );
      await this.setAddFormFieldValue("usageLocation", country?.countryCode??"");
    }
  };
  getSelectedCountryList=()=>{
  let countries=getCountryList(this.props.countryStatesData);
  if(this.state.searchCriteria.usageLocation?.trim()!==""){
    countries=countries.filter(rec=>rec?.toLowerCase()!==this.setCountryList(this.state.searchCriteria.usageLocation)?.toLowerCase());
    countries.unshift(this.setCountryList(this.state.searchCriteria.usageLocation));
  }
  return countries;
  }
  render() {
    return (
      <Dialog
        open={this.props.open}
        className="vpa-dialog-Panel"
        header={
          <>
            <Text>
              {IntlUtil.getText(this._intl_ns_vpa_users, "content.filterUsers")}
            </Text>
            <Divider size={1} />
          </>
        }
        content={
          <Grid fluid className="page-grid m-l-0 p-l-0">
            <Row>
              <Col xl={12} lg={12} md={12} sm={12} xs={12} className="p-l-0">
                <RadioGroup
                  name="filterType"
                  id="filterType"
                  defaultChecked={this.state.searchCriteria?.filterType}
                  checkedValue={this.state.searchCriteria?.filterType}
                  vertical
                  className="vpa-inv-radio"
                  items={this.getConditions()}
                  onCheckedValueChange={(e, select) => {
                    this.setAddFormFieldValue("filterType", select.value);
                  }}
                />
              </Col>
            </Row>
            <Row className="m-t-5">
              <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                <div className="m-t-10">
                  <FormLabel className="page-text text-semibold text-fc-dark">
                    {IntlUtil.getText(
                      this._intl_ns_vpa_users,
                      "content.displayName"
                    )}
                  </FormLabel>
                </div>
                <div className="m-t-10">
                  <Input
                    maxLength="100"
                    type="text"
                    inverted
                    className="vpa-inventory-input"
                    id="name"
                    name="name"
                    value={this.state.searchCriteria.name}
                    onChange={(e) => {
                      this.setAddFormFieldValue(e.target.name, e.target.value);
                    }}
                  />
                </div>
              </Col>
            </Row>
            <Row className="m-t-5">
              <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                <div className="m-t-10">
                  <FormLabel className="page-text text-semibold text-fc-dark">
                    {IntlUtil.getText(
                      this._intl_ns_vpa_users,
                      "content.userName"
                    )}
                  </FormLabel>
                </div>
                <div className="m-t-10">
                  <Input
                    maxLength="100"
                    type="text"
                    inverted
                    className="vpa-inventory-input"
                    id="email"
                    name="email"
                    value={this.state.searchCriteria.email}
                    onChange={(e) => {
                      this.setAddFormFieldValue(e.target.name, e.target.value);
                    }}
                  />
                </div>
              </Col>
            </Row>
            <Row className="m-t-5">
              <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                <div className="m-t-10">
                  <FormLabel className="page-text text-semibold text-fc-dark">
                    {IntlUtil.getText(
                      this._intl_ns_vpa_users,
                      "content.phoneNumber"
                    )}
                  </FormLabel>
                </div>
                <div className="m-t-10">
                  <Input
                    maxLength="100"
                    type="text"
                    inverted
                    className="vpa-inventory-input"
                    id="phone"
                    name="phone"
                    value={this.state.searchCriteria.phone}
                    onChange={(e) => {
                      this.setAddFormFieldValue(e.target.name, e.target.value);
                    }}
                  />
                </div>
                <Text className="text-fc-red text-fs-s m-t-0 m-b-0">
                  {this.state.isFormDataErrorStatus === true
                    ? this.state.errorMessage
                    : null}
                </Text>
              </Col>
            </Row>
            <Row className="m-t-5">
              <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                <div className="m-t-10">
                  <FormLabel className="page-text text-semibold text-fc-dark">
                    {IntlUtil.getText(
                      this._intl_ns_vpa_users,
                      "content.callingPolicy"
                    )}
                  </FormLabel>
                </div>
                <div className="m-t-10">
                  <Dropdown
                    inverted
                    className="vpa-dropdown"
                    id="policyId"
                    name="policyId"
                    items={
                      this.getListOfPolicy(
                        this.props.usersRoutingPoliciesList
                      ) || []
                    }
                    placeholder={IntlUtil.getText(
                      this._intl_ns_vpa_users,
                      "content.selectPolicy"
                    )}
                    highlightFirstItemOnOpen={true}
                    value={this.state.searchCriteria?.policyId}
                    renderItem={(Item, props) => {
                      if (props.key === "") {
                        return <Item {...props} header={"None"} />;
                      } else {
                        return <Item {...props} header={props.header} />;
                      }
                    }}
                    onChange={(e, select) => {
                      this.setAddFormFieldValue("policyId", select.value);
                    }}
                  />
                </div>
              </Col>
            </Row>
            <Row className="m-t-5">
              <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                <div className="m-t-10">
                  <FormLabel className="page-text text-semibold text-fc-dark">
                    {IntlUtil.getText(
                      this._intl_ns_vpa_users,
                      "content.country"
                    )}
                  </FormLabel>
                </div>
                <div className="m-t-10">
                  <Dropdown
                    inverted
                    className="vpa-dropdown"
                    id="usageLocation"
                    name="usageLocation"
                    items={this.getSelectedCountryList()||[]}
                    placeholder={IntlUtil.getText(
                      this._intl_ns_vpa_users,
                      "content.selectCountry"
                    )}
                    selected
                    highlightFirstItemOnOpen={true}
                  
                    value={this.setCountryList(
                      this.state.searchCriteria.usageLocation
                    )}
                    searchInput={{
                      input: {
                        children: (DropdownSearchInput, props) => (
                          <Ref innerRef={this.countryRef}>
                            <DropdownSearchInput  {...props} />
                          </Ref>
                        ),
                      },
                      
                    }}
                    search={(filteredItemsByValue, searchQuery) => {
                      const result = filteredItemsByValue.filter(
                        (item) =>
                          item.toLowerCase() &&
                          _.startsWith(
                            item.toLowerCase(),
                            searchQuery.toLowerCase()
                          )
                      );
                      if (result.length === 0) {
                        return [];
                      }
                      return result;
                    }}
                    
                    
                    onChange={async (e, select) => {
                      await this.handleCountryChange(e, select);
                    }}
                  />
                </div>
              </Col>
            </Row>
            <Row className="m-t-5">
              <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                <div className="m-t-10">
                  <FormLabel className="page-text text-semibold text-fc-dark">
                    {IntlUtil.getText(
                      this._intl_ns_vpa_users,
                      "content.phoneNumberAssignmentStatus"
                    )}
                  </FormLabel>
                </div>
                <div className="m-t-10">
                  <RadioGroup
                    id="numberAssignmentStatus"
                    name="numberAssignmentStatus"
                    checkedValue={this.state.searchCriteria.numberAssignmentStatus}

                    items={this.state.numberAssignmentStatusList || []}
                    onCheckedValueChange={(e, props) =>
                      this.setAddFormFieldValue(
                        "numberAssignmentStatus",
                        props.value
                      )
                    }
                  />
                </div>
              </Col>
            </Row>
          </Grid>
        }
        footer={{
          children: () => {
            return (
              <Flex gap="gap.small">
                <Button
                  disabled={!this.state.isFormDataFilled}
                  className="vpa-usn-button-sm"
                  onClick={this.handleSearch}
                  primary
                  content={IntlUtil.getText(
                    this._intl_ns_vpa_common,
                    "content.apply"
                  )}
                />
                <Button
                  onClick={() => this.clearFilters()}
                  content={IntlUtil.getText(
                    this._intl_ns_vpa_common,
                    "content.clear"
                  )}
                />
                <Button
                  onClick={() => this.closeDialogBox()}
                  content={IntlUtil.getText(
                    this._intl_ns_vpa_common,
                    "content.close"
                  )}
                />
              </Flex>
            );
          },
        }}
      />
    );
  }
}

export default UserFilter;
